import { Injectable } from '@angular/core';

import { DocumentsDataInner, MediaDocumentData, ParagraphRelatedItemsData } from '@generated/content';
import { Card, CmsComponentConfig, RelatedItems } from '@interfaces/config';
import { CmsComponentNodeData } from '@interfaces/index';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { CardComponentResolver } from '@services/resolvers/component-resolvers/card-component/card-component-resolver';
import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';
import { CmsComponentTypeEnum } from '@models/enums';

@Injectable({ providedIn: 'root' })
export class RelatedItemsComponentResolver extends BaseComponentResolver {
  static override instance: RelatedItemsComponentResolver;
  private readonly componentType = RelatedItems.TypeEnum;

  static getInstance(): RelatedItemsComponentResolver {
    return (RelatedItemsComponentResolver.instance ||= new RelatedItemsComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphRelatedItemsData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<RelatedItems.ComponentConfig> | null {
    if (!node) {
      return null;
    }

    this.nodePageData = nodePageData;

    const items = this.getItems(node);

    let headline: RelatedItems.HeadlineConfig;

    if (node.attributes.field_title_relateditems) {
      headline = { title: this.hyphenate(node.attributes.field_title_relateditems) };

      if (node.attributes.field_link_relateditems) {
        headline.link = {
          label: this.hyphenate(node.attributes.field_link_relateditems.title),
          href: node.attributes.field_link_relateditems.url,
        };
      }
    }

    return {
      componentType: this.componentType,
      config: { nodeId: BaseComponentResolver.getNodeId(node), items, headline },
    };
  }

  public getItems(node: ParagraphRelatedItemsData): Card.ComponentConfig[] {
    let items: DocumentsDataInner[];

    try {
      items = node.relationships.field_related_items_ri.data;
    } catch (e) {
      return null;
    }

    const configs = CardComponentResolver.resolveComponentConfigs(items as MediaDocumentData[], this.nodePageData) || [];

    return configs.map(config => {
      if (config.imageConfig) {
        config.imageConfig.sizes = MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.RELATED_ITEMS);
        config.imageConfig.fill = false;
      }

      return config;
    });
  }
}
